import React from "react";
import PropTypes from "prop-types";

import "./index.scss";

export function TextArea({ value, onChange, placeholder, className, autoFocus, onPaste, disabled, onKeyDown, ...rest }) {
    const resolvedClassName = ["text-area", className].filter(Boolean).join(" ");

    return (
        <textarea
            className={resolvedClassName}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            autoFocus={autoFocus}
            onPaste={onPaste}
            disabled={disabled}
            onKeyDown={onKeyDown}
            {...rest}
        />
    );
}

TextArea.propTypes = {
    className: PropTypes.string,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    autoFocus: PropTypes.bool,
    onPaste: PropTypes.func,
    disabled: PropTypes.bool,
    onKeyDown: PropTypes.func,
};

TextArea.defaultProps = {
    className: "",
    placeholder: "",
    autoFocus: true,
    onPaste: undefined,
    disabled: false,
    onKeyDown: undefined,
};
